<form [formGroup]="form" autocomplete="off" (ngSubmit)="onSubmit()" novalidate>
  <form-group-context label="Name" formControlName="name">
    <form-group-simple name="name" placeholder="Name"></form-group-simple>
  </form-group-context>


  <form-group-context label="Store" formControlName="store">
    <form-group-select entity="store"
                       bindLabel="name"
                       [searchable]="true"
                       [storeQuery]="null"
                       bindValue="id"
                       placeholder="Store"></form-group-select>
  </form-group-context>


  <form-group-context label="Product" formControlName="product">
    <form-group-select entity="product"
                       bindLabel="name"
                       [searchable]="true"
                       [storeQuery]="{parentStore: data?.store?.id || data?.store}"
                       bindValue="id"
                       placeholder="Product"></form-group-select>
  </form-group-context>

  <form-group-context label="Key" formControlName="key">
    <form-group-simple name="key" placeholder="Key"></form-group-simple>
  </form-group-context>

  <form-group-context label="Active" formControlName="active">
    <form-group-simple type="checkbox" name="active"></form-group-simple>
  </form-group-context>


  <form-group-context label="Multiple" formControlName="multiple">
    <form-group-simple type="checkbox" name="multiple"></form-group-simple>
  </form-group-context>

  <form-group-context label="Circle" formControlName="circle">
    <form-group-simple name="circle" inputType="number" placeholder="5"></form-group-simple>
  </form-group-context>

  <form-group-context label="Time out (minutes)" formControlName="timeOut">
    <form-group-simple name="timeOut" inputType="number" placeholder="60"></form-group-simple>
  </form-group-context>

  <form-group-context label="Apple" formControlName="apple">
    <form-group-simple type="checkbox" name="apple"></form-group-simple>
  </form-group-context>

  <form-group-context label="Google" formControlName="google">
    <form-group-simple type="checkbox" name="google"></form-group-simple>
  </form-group-context>

  <form-group-context label="Actions" [hidden]="actions.isEmpty" #actions>
    <ng-content select="[form][actions]"></ng-content>
  </form-group-context>

  <div class="mt-3">
    <ng-content></ng-content>
  </div>
</form>
